.box {
  accent-color: var(--c-brand);
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

.bar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
  padding: 4px 8px 4px 12px;
  border-radius: var(--radius-md);
  background: var(--c-brand-subtle);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--c-brand) 35%, transparent);
  min-width: 0;
}

.count {
  font-size: var(--text-caption);
  font-weight: 600;
  white-space: nowrap;
}

.grow {
  flex: 1;
}
